// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1ShsK","rootSuccess":"CompleteLink_rootSuccess__27Sn5","rootFailure":"CompleteLink_rootFailure__2j6gL","isDisabled":"CompleteLink_isDisabled__35Q46"};